import { imagesType } from "../type";

const initalState = {
  path: "",
  loading:false,
};

const imageReducer = (state = initalState, action) => {
  const { type, payload = {} } = action;

  switch (type) {
    case imagesType.DOWNLOAD:
      return {
        ...state,
        loading:false,
        path: payload.path
      };
    
      case imagesType.LOADING:
        return{
          ...state,
          loading: payload
        }

    default:
      return state;
  }
};


export default imageReducer;
